import { render } from "./CommandPalette.vue?vue&type=template&id=13dc8eec&scoped=true"
import script from "./CommandPalette.vue?vue&type=script&lang=js"
export * from "./CommandPalette.vue?vue&type=script&lang=js"

import "./CommandPalette.vue?vue&type=style&index=0&id=13dc8eec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dc8eec"]])

export default __exports__